import React from "react";

export const formSubmitMapper = (data) => ({
  id_sales_order: data.id_sales_order,
  is_spk: data.is_spk ? "true" : "false",
  tgl_close_order: data.tgl_close_sales_order,
});
